module.exports = __webpack_public_path__ + "static/media/alfred_with_pencil.39eada71.png";